var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSatellite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21H3V20.25C3 18 4.65 15.9 6.825 15.3C5.7 13.8 5.1 12 5.1 10.125C5.1 7.8 6 5.625 7.65 3.975L8.175 3.45L13.8 9.075L15.975 6.9C15.9 6.525 15.75 6.075 15.75 5.625C15.75 4.2 16.95 3 18.375 3C19.8 3 21 4.2 21 5.625C21 7.05 19.8 8.25 18.375 8.25C17.925 8.25 17.475 8.1 17.1 7.95L14.925 10.125L20.55 15.75L20.025 16.275C18.375 17.925 16.2 18.825 13.875 18.825C13.65 18.825 13.425 18.825 13.275 18.825C13.425 19.2 13.5 19.725 13.5 20.25V21ZM4.575 19.5H11.85C11.775 19.2 11.625 18.825 11.325 18.45C10.05 18.075 8.925 17.475 7.95 16.575C6.45 16.725 4.95 18 4.575 19.5ZM8.25 5.625C7.2 6.9 6.675 8.475 6.675 10.125C6.675 12.075 7.425 13.875 8.775 15.225C10.125 16.575 11.925 17.325 13.875 17.325C15.525 17.325 17.1 16.725 18.375 15.75L8.25 5.625ZM18.375 4.5C17.775 4.5 17.25 5.025 17.25 5.625C17.25 6.225 17.775 6.75 18.375 6.75C18.975 6.75 19.5 6.225 19.5 5.625C19.5 5.025 18.975 4.5 18.375 4.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSatellite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/satellite.0fe6fb330d4c537bdd470b9c477d5bc9.svg";